import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { routesLinks, ResourceHub_URL } from '../../../utils/RouteConstants';
import styles from './Nav.module.css';
import HamburgerMenuIcon from '../../../assets/icons/hamburger-menu.svg';

const LOGO_SRC       = '/assets/logo.svg';
const LOGO_WHITE_SRC = '/assets/logo-white.svg';

const NAV_LINKS = [
  { label: 'About Us', href: routesLinks.aboutus, isRoute: true },
  { label: 'Careers',  href: routesLinks.careers, isRoute: true },
  { label: 'Resource Hub', href: ResourceHub_URL, isRoute: false },
  /* Optional: Keep 'How It Works' if desired for mobile landing anchors, 
     but web version doesn't have it in the main menu list. 
     Keeping it for now but pointing to the home section. */
  // { label: 'How It Works', href: '//#how-it-works', isRoute: true },
];

export default function Nav({ handleBtnClick }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = (link) => {
    setMenuOpen(false);
    if (link.isRoute) {
      navigate(link.href);
    } else {
      window.open(link.href, "_blank", "noopener,noreferrer");
    }
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close menu on escape
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <header
      className={`${styles.header} ${scrolled ? styles.headerScrolled : ''}`}
      role="banner"
    >
      <div className={styles.inner}>
        {/* Logo */}
        <a 
          href="/"
          className={styles.logo} 
          onClick={(e) => { e.preventDefault(); navigate("/"); }} 
          aria-label="CoSchool Home"
        >
          <img src={LOGO_SRC} alt="CoSchool" width="131" height="24" />
        </a>

        {/* Desktop Nav */}
        <nav className={styles.desktopNav} aria-label="Main navigation">
          <ul className={styles.navList}>
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <a 
                  href={link.href}
                  onClick={(e) => {
                    if (link.isRoute) {
                      e.preventDefault();
                      handleNavigate(link);
                    }
                  }} 
                  className={styles.navLink}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Desktop CTA */}
        <button 
          onClick={(e) => handleBtnClick(e.target, "Book a Demo Nav")} 
          className={`wm-btn-primary ${styles.desktopCta}`}
          style={{ border: 'none', cursor: 'pointer' }}
        >
          Book a Demo
        </button>

        {/* Mobile hamburger */}
        <button
          className={styles.hamburger}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          onClick={() => setMenuOpen((o) => !o)}
        >
          <img
            src={HamburgerMenuIcon}
            alt=""
            width="18"
            height="18"
          />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <nav
          id="mobile-menu"
          className={styles.mobileMenu}
          aria-label="Mobile navigation"
        >
          <ul className={styles.mobileNavList}>
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  className={styles.mobileNavLink}
                  onClick={(e) => {
                    if (link.isRoute) {
                      e.preventDefault();
                      handleNavigate(link);
                    } else {
                      setMenuOpen(false);
                    }
                  }}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <button 
                className={`wm-btn-primary ${styles.mobileCta}`} 
                onClick={(e) => {
                  setMenuOpen(false);
                  handleBtnClick(e.target, "Book a Demo Nav Mobile");
                }}
                style={{ border: 'none', width: '100%', cursor: 'pointer' }}
              >
                Book a Demo
              </button>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}
